import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ca-ratio',
    templateUrl: './ratio.component.html',
    styleUrls: ['./ratio.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatioComponent {
    @Input() value = 0;
    @Input() overallValue = 0;
    @Input() height = 2;
    @Input() warningBackgroundWhenMax = false;
}
